export default {"src":"/account/preferences/_next/static/media/Phone.81669ebe.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};